import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { ListPaperColumn } from '../list-item';

interface StageTransitionColumnProps {
  who: string | null;
  when: JSX.Element;
  label?: string;
  wrap?: boolean;
}

export const StageTransitionColumn: FC<StageTransitionColumnProps> = ({ who, when, label, wrap = true }) => {
  const { t } = useTranslation();

  return (
    <ListPaperColumn
      data-testid="transfers-list-column-stage-transition"
      label={label}
      wrap={wrap}
      sx={{
        overflow: 'visible',
        '& > label': {
          textTransform: 'capitalize',
        },
        '& > div': {
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          overflow: 'visible',
          textOverflow: 'unset',
          width: '100%',
        },
        '@media (max-width: 600px)': {
          '& .MuiTypography-root, & span': {
            fontSize: '0.875rem',
            minHeight: '1.25em',
          },
        },
      }}
    >
      <span>
        {who || t('common:terms.system')}
        <span style={{ marginLeft: '8px' }}>
          ({when})
        </span>
      </span>
    </ListPaperColumn>
  );
};
